<main class="main-dashboard">
  <article class="main-canvas">
      <section class="canvas-container">
          <section class="dashboard-items">
               <div class="canvas-item">
                  <div class="canvas-header row justify-content-between align-items-center">
                      <div class="title col-sm-6">
                          <div class="d-flex align-items-center">
                                <div class="edit">
                                    <button title="back page" (click)="backToGoalProfile()">
                                    <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                              <h3 class="px-3">Overall Goals Performance</h3>
                          </div>
                      </div>
                      <div class="col-sm-6" style="display: flex; justify-content: flex-end; align-items: center;">
                          <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                              <button type="button" title="Edit" (click)="editOpenModal()" data-bs-toggle="modal" data-bs-target="#createForm">
                                  <span><i class="ri-pencil-line"></i></span>
                              </button>
                          </div>
                      </div>
                  </div>

                  <div class="canvas-header row justify-content-between align-items-center">
                    <div class="row p-0">
                        <div class="col-sm-12 p-0">
                            <div class="canvas-data px-0">
                                <form [formGroup]="filterForm">
                                    <div class="row m-0">
                                        <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 mb-2">
                                            <div class="input">
                                                <div class="input-item"> 
                                                    <input list="taskOwnerDatalist" formControlName="userId" placeholder="Select Employee Name" />
                                                    <datalist id="taskOwnerDatalist">
                                                        <option [value]="item" *ngFor="let item of userDropdownList"></option>
                                                    </datalist>
                                                    <label class="floating-label">Employee Name*</label>
                                                    <i class="ri-user-line"></i>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 mb-2">
                                            <div class="input">
                                                <div class="input-item">
                                                    <select formControlName="year" placeholder="Select Year">
                                                        <option value="" disabled selected>Select Year</option>
                                                        <option value="2021">2021</option>
                                                        <option value="2022">2022</option>
                                                        <option value="2023">2023</option>
                                                        <option value="2024">2024</option>
                                                        <option value="2025">2025</option>
                                                        <option value="2026">2026</option>
                                                    </select>
                                                    <i class="ri-calendar-line"></i>
                                                    <label class="floating-label-special">Year*</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <button type="button" class="btn" (click)="getPerformanceReport()">
                                                <div>Submit</div>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                  <ag-grid-angular
                      class="ag-theme-material"
                      (gridReady)="onGridReady($event)" 
                      [rowData]="rowData" 
                      [columnDefs]="columnDefs"
                      [defaultColDef]="defaultColDef"
                      [suppressRowClickSelection]="true"
                      [rowSelection]="rowSelection"
                      (selectionChanged)="onSelectionChanged($event)"
                  >
                  </ag-grid-angular>
               </div>
          </section>
      </section>
  </article>
</main>

<div class="modal fade bd-example-modal-lg" id="createForm" tabindex="-1">
  <div class="modal-dialog modal-lg">
      <div class="modal-content pl-5 pr-5">
          <form [formGroup]="performancegoalsForm">
              <div class="modal-header">
                  <h5 class="modal-title">Update Performance Template</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div class="modal-body">
                  <div class="row">               
                      <div class="input">
                          <div class="input-item">
                              <input formControlName="title" type="text" disabled>
                              <label for="title" class="floating-label-special">Title</label>
                              <i class="ri-file-list-line"></i>
                          </div>
                          <!-- <mat-error *ngIf="f.title.touched && f.title.invalid" class="alert alert-danger">
                              <mat-error *ngIf="f.title.errors.required"><Title></Title> is required</mat-error>
                          </mat-error> -->
                      </div>
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input type="text" formControlName="userId" disabled/>
                                  <label class="floating-label-special">Employee Name</label>
                                  <i class="ri-file-list-line"></i>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="kra" type="text" disabled>
                                  <label class="floating-label-special">KRA</label>
                                  <i class="ri-calendar-check-line"></i>
                              </div>
                             
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="kpi" type="text" disabled>
                                  <label class="floating-label-special">KPI</label>
                                  <i class="ri-calendar-check-line"></i>
                              </div>
                              <!-- <mat-error *ngIf="f.deadline.touched && f.deadline.invalid" class="alert alert-danger">
                                  <mat-error *ngIf="f.deadline.errors.required">Deadline is required</mat-error>
                              </mat-error> -->
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="weightage" type="text" disabled>
                                  <label class="floating-label-special">Weightage</label>
                                  <i class="ri-file-list-line"></i>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="base" type="text" disabled>
                                  <label class="floating-label-special">Base</label>
                                  <i class="ri-message-2-line"></i>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="target" type="text" disabled>
                                  <label class="floating-label-special">Target</label>
                                  <i class="ri-message-2-line"></i>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="startDate" type="date" disabled>
                                  <label class="floating-label-special">Start Date</label>
                                  <i class="ri-calendar-2-line"></i>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="endDate" type="date" disabled>
                                  <label class="floating-label-special">End Date</label>
                                  <i class="ri-calendar-2-line"></i>
                              </div>
                          </div>
                      </div>

                      <!-- Mid-Year Review -->
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="midYearReview" type="text" disabled>
                                  <label class="floating-label-special">Mid-Year Review</label>
                                  <i class="ri-message-2-line"></i>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="employeeMidYearReview" type="text" disabled>
                                  <label class="floating-label-special">Employee Mid-Year Review</label>
                                  <i class="ri-message-2-line"></i>
                              </div>
                          </div>
                      </div>

                      <!-- End-Year Review -->

                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="employeeEndYearReview" type="text">
                                  <label class="floating-label-special">Employee End-Year Review</label>
                                  <i class="ri-message-2-line"></i>
                              </div>
                          </div>
                      </div>

                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="endYearReview" type="text">
                                  <label class="floating-label-special">End-Year Review</label>
                                  <i class="ri-message-2-line"></i>
                              </div>
                          </div>
                      </div>

                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="employeeScore" type="text">
                                  <label class="floating-label-special">Employee Score</label>
                                  <i class="ri-message-2-line"></i>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <select formControlName="ratingByManager">
                                      <option value="" disabled selected>Select Rating By Manager</option>
                                      <option value="Does Not Meet Expectations">Does Not Meet Expectations</option>
                                      <option value="Partially Meet Expectations">Partially Meet Expectations</option>
                                      <option value="Meet Expectations">Meet Expectations</option>
                                      <option value="Exceeds Expectations">Exceeds Expectations</option>
                                  </select>
                                  <label  class="floating-label-special">Rating By Manager</label >
                                  <i class="ri-message-2-line"></i>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="managerRatingScore" type="text">
                                  <label class="floating-label">Manager Rating Score</label>
                                  <i class="ri-message-2-line"></i>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <select formControlName="behavioral" placeholder="Select Goal Type">
                                      <option value="" disabled selected>Select Goal Type</option>
                                      <option [ngValue]="false">Technical</option>
                                      <option [ngValue]="true">behavioral</option>
                                  </select>
                                  <label class="floating-label-special">Goal Type</label>
                                  <i class="ri-calendar-2-line"></i>
                              </div>
                          </div>
                      </div>
  
                      <div class="col-sm-6">
                          <div class="input">
                              <div class="input-item">
                                  <select formControlName="status" placeholder="Select Status">
                                      <option value="" disabled selected>Select Status</option>
                                      <option value="Mid-Year Review">Mid-Year Review</option>
                                      <option value="End-Year Review">End-Year Review</option>
                                      <option value="HR Review">HR Review</option>
                                  </select>
                                  <label class="floating-label-special">Status</label>
                                  <i class="ri-check-double-line"></i>
                              </div>
                          </div>
                      </div>
                  </div>                    
              </div>
              <div class="modal-footer">
                  <button type="button" id="closeCreateModal"  class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                  <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updategoal()">Update</button>
              </div>
          </form>
      </div>
  </div>
</div>

